const APIs = {
  PAYMENTS: 'admin/invoices',
  SINGLE_PAYMENT: 'admin/invoices/:id',
}

export default APIs
